export const PEER_GROUP_PERCENTILES = [
	'PERCENTILE_5',
	'PERCENTILE_25',
	'PERCENTILE_50',
	'PERCENTILE_75',
	'PERCENTILE_95'
];
